import { render, staticRenderFns } from "./WonderTopicTable.vue?vue&type=template&id=7019d21c"
import script from "./WonderTopicTable.vue?vue&type=script&lang=js"
export * from "./WonderTopicTable.vue?vue&type=script&lang=js"
import style0 from "./WonderTopicTable.vue?vue&type=style&index=0&id=7019d21c&prod&lang=css"
import style1 from "./WonderTopicTable.vue?vue&type=style&index=1&id=7019d21c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports